import 'css-chunksrc/client/scenes/workloads/wbs/secondaryCriteria/styles.scss';export default {
  "secondaryCriteria": "_secondaryCriteria_h2nn2_1",
  "row": "_row_h2nn2_8",
  "flexContainer": "_flexContainer_h2nn2_24",
  "spacer": "_spacer_h2nn2_30",
  "comment": "_comment_h2nn2_34",
  "file": "_file_h2nn2_38"
};